export enum TicketCategoryEnum {
  TOTAL = 'total',
  INBOX = 'inbox',
  OUTBOX = 'outbox',
  MY_ISSUES = 'myIssues',
  WATCHING_ISSUES = 'watchingIssues'
}
